/**
 * Returns true when the keyboard event originates from (or the page focus is
 * on) a text input, textarea, select, or contenteditable element. Used to
 * avoid firing pad keyboard shortcuts while the user is typing.
 */
const isEditableElement = (el: EventTarget | Element | null): boolean => {
  if (!el || !(el instanceof HTMLElement)) return false
  const tag = el.tagName
  return (
    tag === "INPUT" ||
    tag === "TEXTAREA" ||
    tag === "SELECT" ||
    el.isContentEditable
  )
}

const isTextFieldFocused = (e?: KeyboardEvent): boolean =>
  isEditableElement(e?.target ?? null) ||
  isEditableElement(document.activeElement)

export default isTextFieldFocused
